import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const countryToIso: Record<string, string> = {
  "Albania": "al",
  "Armenia": "am",
  "Australia": "au",
  "Austria": "at",
  "Azerbaijan": "az",
  "Belgium": "be",
  "Bulgaria": "bg",
  "Croatia": "hr",
  "Cyprus": "cy",
  "Czechia": "cz",
  "Denmark": "dk",
  "Estonia": "ee",
  "Finland": "fi",
  "France": "fr",
  "Georgia": "ge",
  "Germany": "de",
  "Greece": "gr",
  "Israel": "il",
  "Italy": "it",
  "Latvia": "lv",
  "Lithuania": "lt",
  "Luxembourg": "lu",
  "Malta": "mt",
  "Moldova": "md",
  "Montenegro": "me",
  "Norway": "no",
  "Poland": "pl",
  "Portugal": "pt",
  "Romania": "ro",
  "San Marino": "sm",
  "Serbia": "rs",
  "Sweden": "se",
  "Switzerland": "ch",
  "Ukraine": "ua",
  "United Kingdom": "gb"
};

export const flagColors: Record<string, string[]> = {
  "Moldova": ["#0046AE", "#FFD200", "#CC092F"],
  "Sweden": ["#006AA7", "#FECC00"],
  "Croatia": ["#FF0000", "#FFFFFF", "#171796"],
  "Greece": ["#005BAE", "#FFFFFF"],
  "Portugal": ["#006600", "#FF0000"],
  "Georgia": ["#FF0000", "#FFFFFF"],
  "Finland": ["#FFFFFF", "#003580"],
  "Montenegro": ["#C40308", "#D0A650"],
  "Estonia": ["#0072CE", "#333333", "#FFFFFF"],
  "Israel": ["#FFFFFF", "#0038B8"],
  "Belgium": ["#333333", "#FFE936", "#FF0F21"],
  "Lithuania": ["#FFB81C", "#046A38", "#BE3A34"],
  "San Marino": ["#FFFFFF", "#5EB6E4"],
  "Poland": ["#FFFFFF", "#DC143C"],
  "Serbia": ["#C6363C", "#1E5699", "#FFFFFF"],
  "Italy": ["#008C45", "#F4F5F0", "#CD212A"],
  "Germany": ["#333333", "#FF0000", "#FFCC00"],
  "Albania": ["#E41E20", "#333333"],
  "Armenia": ["#FF0000", "#0033A0", "#F2A800"],
  "Australia": ["#00008B", "#FF0000", "#FFFFFF"],
  "Austria": ["#ED2939", "#FFFFFF"],
  "Azerbaijan": ["#00B5E2", "#EF3340", "#509E2F"],
  "Bulgaria": ["#FFFFFF", "#00966E", "#D62612"],
  "Cyprus": ["#FFFFFF", "#D57800", "#4B6735"],
  "Czechia": ["#11457E", "#FFFFFF", "#D7141A"],
  "Denmark": ["#C60C30", "#FFFFFF"],
  "France": ["#002395", "#FFFFFF", "#ED2939"],
  "Latvia": ["#9E3039", "#FFFFFF"],
  "Luxembourg": ["#EA1423", "#FFFFFF", "#51ADDA"],
  "Malta": ["#FFFFFF", "#D62828"],
  "Norway": ["#EF2B2D", "#00205B", "#FFFFFF"],
  "Romania": ["#002B7F", "#FCD116", "#CE1126"],
  "Switzerland": ["#FF0000", "#FFFFFF"],
  "Ukraine": ["#0057B7", "#FFD700"],
  "United Kingdom": ["#012169", "#FFFFFF", "#C8102E"],
};

export function getFlagGradient(country: string) {
  const colors = flagColors[country];
  if (!colors || colors.length === 0) return "linear-gradient(to right, #666, #999)";
  
  if (colors.length === 1) return colors[0];
  
  return `linear-gradient(to bottom right, ${colors.join(", ")})`;
}

export function getFlagUrl(country: string) {
  const code = countryToIso[country];
  if (!code) return null;
  return `https://flagcdn.com/w160/${code}.png`;
}
